import Card from "@mui/material/Card";
import { Typography, Box } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import WarningIcon from "@mui/icons-material/Warning";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import CheckCircleIcon from "@mui/icons-material/CheckCircle"; // For Synced Orders
import StorageIcon from "@mui/icons-material/Storage"; // For Staging Orders
import { getOrderStats } from "../../services/integrationService";
import { getSyncedOrderStats } from "../../services/integrationService";

function OrdersOverview() {
  const [orderStats, setOrderStats] = useState({ unsynced: 0, maxAging: 0 });
  const [additionalStats, setAdditionalStats] = useState({
    salecodePushedOrdersCount: 0,
    stagingDbCount: 0,
  });

  const fetchOrderStats = useCallback(async () => {
    const data = await getOrderStats();
    setOrderStats(data.data);
    const data1 = await getSyncedOrderStats();
    setAdditionalStats(data1.data);
    console.log(data1);
  }, []);

  useEffect(() => {
    fetchOrderStats();
  }, [fetchOrderStats]);

  return (
    <Card className="h-100">
      <Box display="flex" flexDirection="column" pt={3} px={3}>
        <Typography variant="h6" fontWeight="medium">
          Orders Stats
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            mt: 10,
            mb: 2,
          }}
        >
          {/* Unsynced Orders */}
          <Box display="flex" flexDirection="column" justifyContent="flex-end">
            <Box display="flex" alignItems="center">
              <Box
                className="icon icon-shape icon-xxs shadow border-radius-sm bg-gradient-info text-center me-2 d-flex align-items-center justify-content-center"
                sx={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "20%",
                  background: "linear-gradient(87deg, #11cdef 0, #1171ef 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <AccessTimeFilledIcon
                  sx={{ fontSize: "15px", color: "#11cdef" }}
                  style={{ color: "white" }}
                />
              </Box>
              <Typography fontSize="14px" mt={1} mb={0} mx={1}>
                Unsynced Orders
              </Typography>
            </Box>
            <Typography fontSize="24px" fontWeight="bold" mt={1} mb={0} mx={1}>
              {orderStats["unsynced"]}
            </Typography>
          </Box>

          {/* Max Aging */}
          <Box display="flex" flexDirection="column">
            <Box display="flex" alignItems="center">
              <Box
                className="icon icon-shape icon-xxs shadow border-radius-sm bg-gradient-info text-center me-2 d-flex align-items-center justify-content-center"
                sx={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "20%",
                  background: "linear-gradient(87deg, #f44336 0%, #d32f2f 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <WarningIcon
                  sx={{ fontSize: "15px", color: "#11cdef", backgroundColor: "error" }}
                  style={{ color: "white" }}
                />
              </Box>
              <Typography fontSize="14px" mt={1} mb={0} mx={1}>
                Max Aging
              </Typography>
            </Box>
            <Typography fontSize="24px" fontWeight="bold" mt={1} mb={0} mx={1}>
              {orderStats["maxAging"]} minutes
            </Typography>
          </Box>
        </Box>

        {/* New Stats Section */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            mt: 5, // Add some spacing below the first row
          }}
        >
          {/* Synced Orders */}
          <Box display="flex" flexDirection="column">
            <Box display="flex" alignItems="center">
            <Box
                className="icon icon-shape icon-xxs shadow border-radius-sm bg-gradient-info text-center me-2 d-flex align-items-center justify-content-center"
                sx={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "20%",
                  background: "linear-gradient(87deg, #11cdef 0, #1171ef 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <AccessTimeFilledIcon
                  sx={{ fontSize: "15px", color: "#11cdef" }}
                  style={{ color: "white" }}
                />
              </Box>
              <Typography fontSize="14px" mt={1} mb={0} mx={1}>
                Synced Orders
              </Typography>
            </Box>
            <Typography fontSize="24px" fontWeight="bold" mt={1} mb={0} mx={1}>
              {additionalStats["salecodePushedOrdersCount"]}
            </Typography>
          </Box>

          {/* Staging Orders */}
          <Box display="flex" flexDirection="column">
            <Box display="flex" alignItems="center">
            <Box
                className="icon icon-shape icon-xxs shadow border-radius-sm bg-gradient-info text-center me-2 d-flex align-items-center justify-content-center"
                sx={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "20%",
                  background: "linear-gradient(87deg, #f44336 0%, #d32f2f 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <WarningIcon
                  sx={{ fontSize: "15px", color: "#11cdef", backgroundColor: "error" }}
                  style={{ color: "white" }}
                />
              </Box>
              <Typography fontSize="14px" mt={1} mb={0} mx={1}>
                Staging Orders
              </Typography>
            </Box>
            <Typography fontSize="24px" fontWeight="bold" mt={1} mb={0} mx={1}>
              {additionalStats["stagingDbCount"]}
            </Typography>
          </Box>
        </Box>

        <div>
          <iframe
            src="https://analytics-internal.sellina.io/app/kibana#/visualize/edit/7e9645c0-87c4-11ec-84af-23c75e6b1014?embed=true&_a=(filters:!(),linked:!f,query:(language:kuery,query:'type:Order'),uiState:(),vis:(aggs:!((enabled:!t,id:'1',params:(customLabel:'Order%20Count'),schema:metric,type:count),(enabled:!t,id:'2',params:(drop_partials:!f,extended_bounds:(),field:eventTime,interval:h,min_doc_count:1,scaleMetricValues:!f,timeRange:(from:now%2Fd,to:now%2Fd),useNormalizedEsInterval:!t),schema:segment,type:date_histogram)),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,categoryAxes:!((id:CategoryAxis-1,labels:(filter:!t,show:!t,truncate:100),position:bottom,scale:(type:linear),show:!t,style:(),title:(),type:category)),grid:(categoryLines:!f),labels:(show:!f),legendPosition:right,seriesParams:!((data:(id:'1',label:'Order%20Count'),drawLinesBetweenPoints:!t,lineWidth:2,mode:stacked,show:!t,showCircles:!t,type:histogram,valueAxis:ValueAxis-1)),thresholdLine:(color:%23E7664C,show:!f,style:full,value:10,width:1),times:!(),type:histogram,valueAxes:!((id:ValueAxis-1,labels:(filter:!f,rotate:0,show:!t,truncate:100),name:LeftAxis-1,position:left,scale:(mode:normal,type:linear),show:!t,style:(),title:(text:'Order%20Count'),type:value))),title:HOURLY_ORDERS,type:histogram))&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&indexPattern=d315f600-807a-11ec-84af-23c75e6b1014&type=histogram"
            height="250px"
            width="100%"
            frameBorder="0"
          ></iframe>
        </div>
      </Box>
    </Card>
  );
}

export default OrdersOverview;
